import { post } from "./base";

export const generateSlidesFromLink = async (link, slide) => {
  return post("/extract_link_text/", {
    link,
    slide,
  });
};
